<template>
    <div class="app-container">
        <!-- 顶部操作栏 -->
        <el-card class="operation-card">
            <div class="operation-header">
                <h3>OPPO批量搭建录户</h3>
                <div>
                    <el-button type="primary"  @click="handleAddProject">新增项目</el-button>
                    <el-button type="primary" @click="loadProjects">刷新</el-button>
                </div>
            </div>
        </el-card>

        <!-- 项目列表区域 -->
        <el-card class="projects-card" v-loading="loading">
            <div class="search-bar">
                <el-input v-model="searchKeyword" placeholder="输入项目名搜索" clearable prefix-icon="el-icon-search"
                    style="width: 300px" @input="filterProjects" />
                <span class="search-tip" v-if="filteredProjects.length !== projects.length">
                    共找到 {{ filteredProjects.length }} 个项目
                </span>
            </div>

            <div v-if="filteredProjects.length === 0" class="empty-state">
                <el-empty description="暂无项目数据" />
            </div>

            <!-- 项目列表表格 - 显示所有项目 -->
            <el-table v-else :data="filteredProjects" border stripe class="project-table" empty-text="暂无项目数据">
                <el-table-column prop="projectName" label="项目名称" min-width="200" show-overflow-tooltip />

                <el-table-column label="录户数量" width="120" align="center">
                    <template v-slot="scope">
                        <el-tag type="primary" size="medium">{{ scope.row.accounts.length }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="已配置录户" width="120" align="center">
                    <template v-slot="scope">
                        <el-tag type="success" size="medium">
                            {{ getConfiguredCount(scope.row.accounts) }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="未配置录户" width="120" align="center">
                    <template v-slot="scope">
                        <el-tag type="info" size="medium">
                            {{ getUnconfiguredCount(scope.row.accounts) }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center" fixed="right">
                    <template v-slot="scope">
                        <el-button type="primary" size="small" icon="el-icon-edit" @click="handleEditProject(scope.row)">
                            编辑录户
                        </el-button>
                        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteProject(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 账户编辑弹窗 -->
        <el-dialog :title="'录户管理 - ' + (currentProject ? currentProject.projectName : '')"
            :visible.sync="accountDialogVisible" width="90%" top="5vh" :close-on-click-modal="false"
            @close="closeAccountDialog">
            <div class="dialog-toolbar">
                <div class="left-buttons">
                    <el-button type="success" icon="el-icon-plus" @click="handleAddAccountInDialog">新增录户</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="downloadTemplate">下载模板</el-button>
                    <el-upload
                        :show-file-list="false"
                        accept=".xlsx,.xls"
                        :before-upload="handleExcelUpload"
                        style="display: inline-block; margin-left: 10px;">
                        <el-button type="warning" icon="el-icon-upload2">Excel批量导入</el-button>
                    </el-upload>
                </div>
                <el-button type="primary" @click="saveProjectAccounts" :loading="saveLoading">保存修改</el-button>
            </div>

            <el-table :data="editingAccounts" border stripe class="account-table" height="500" v-loading="accountLoading"
                empty-text="暂无录户数据">
                <el-table-column label="操作" width="80" fixed="left">
                    <template v-slot="scope">
                        <el-button type="danger" icon="el-icon-delete" circle size="mini"
                            @click="handleDeleteAccountInDialog(scope.row, scope.$index)" />
                    </template>
                </el-table-column>

                <el-table-column label="子项目名称" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.twoname" placeholder="请输入子项目名称" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="广告h5落地链接" min-width="200">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.url" placeholder="请输入广告h5落地链接" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="曝光URL" min-width="200">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.baoguangurl" placeholder="请输入曝光URL" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="点击监测链接" min-width="200">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.xiaoshuourl" placeholder="请输入点击监测链接" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="代理商账户id" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.ownerid" placeholder="请输入代理商账户id" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="代理商账户api id" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.apiid" placeholder="请输入代理商账户api id" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="代理商账户apikey" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.apikey" placeholder="请输入代理商账户apikey" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="子账户id" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.zzownerid" placeholder="请输入子账户id" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="账户名称" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.idsname" placeholder="请输入账户名称" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="计划名称" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.planName" placeholder="请输入计划名称" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="hap链接" min-width="200">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.haplink" placeholder="请输入hap链接" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="快应用id" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.appid" placeholder="请输入快应用id" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="定向包id" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.targetid" placeholder="请输入定向包id" size="small" />
                    </template>
                </el-table-column>

                <el-table-column label="创意ID" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.creativityid" placeholder="请输入创意ID" size="small" />
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="accountDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveProjectAccounts" :loading="saveLoading">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import axios from 'axios'
import * as XLSX from 'xlsx'

export default {
    name: 'OppoBatchAccountOpening',
    data() {
        return {
            userId: '',
            loading: false,
            accountLoading: false,
            saveLoading: false,
            projects: [],
            filteredProjects: [],
            searchKeyword: '',
            baseUrl: 'https://control.zjwec.cn/api/oppo',
            accountDialogVisible: false,
            currentProject: null,
            editingAccounts: []
        }
    },
    created() {
        this.userId = this.$route.query.userId

        if (!this.userId) {
            this.$message.warning('您得先登录')
            setTimeout(() => {
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)
        } else {
            this.loadProjects()
        }
    },
    methods: {
        // 获取已配置录户数量（有录户名称的）
        getConfiguredCount(accounts) {
            return accounts.filter(a => a.twoname && a.twoname.trim() !== '').length
        },

        // 获取未配置录户数量（无录户名称的）
        getUnconfiguredCount(accounts) {
            return accounts.filter(a => !a.twoname || a.twoname.trim() === '').length
        },

        // 加载项目列表
        async loadProjects() {
            this.loading = true
            try {
                const response = await axios.get(`${this.baseUrl}/projects`, {
                    params: { userId: this.userId }
                })

                if (response.data.code === 200) {
                    this.projects = response.data.data || []
                    this.filterProjects()
                } else {
                    this.$message.error(response.data.msg || '加载失败')
                }
            } catch (error) {
                console.error('加载项目失败:', error)
                this.$message.error('加载失败: ' + error.message)
            } finally {
                this.loading = false
            }
        },

        // 筛选项目
        filterProjects() {
            if (!this.searchKeyword) {
                this.filteredProjects = [...this.projects]
                return
            }

            const keyword = this.searchKeyword.toLowerCase()
            this.filteredProjects = this.projects.filter(project =>
                project.projectName.toLowerCase().includes(keyword)
            )
        },

        // 新增项目
        handleAddProject() {
            this.$prompt('请输入项目名称', '新增项目', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,50}$/,
                inputErrorMessage: '项目名称长度需在1-50个字符'
            }).then(({ value }) => {
                this.addProject(value)
            }).catch(() => { })
        },

        async addProject(projectName) {
            try {
                const response = await axios.post(`${this.baseUrl}/project/add`, null, {
                    params: {
                        userId: this.userId,
                        projectName: projectName
                    }
                })

                if (response.data.code === 200) {
                    this.$message.success('项目创建成功')
                    this.loadProjects()
                } else {
                    this.$message.error(response.data.msg || '创建失败')
                }
            } catch (error) {
                console.error('创建项目失败:', error)
                this.$message.error('创建失败: ' + error.message)
            }
        },

        // 编辑项目（打开弹窗）
        handleEditProject(project) {
            this.currentProject = project
            this.editingAccounts = JSON.parse(JSON.stringify(project.accounts || []))
            this.accountDialogVisible = true
        },

        // 关闭弹窗
        closeAccountDialog() {
            this.accountDialogVisible = false
            this.currentProject = null
            this.editingAccounts = []
        },

        // 在弹窗中新增录户
        handleAddAccountInDialog() {
            const newAccount = {
                id: null,
                projectId: this.currentProject.projectId,
                username: this.currentProject.projectName,
                twoname: '',
                url: '',
                baoguangurl: '',
                xiaoshuourl: '',
                ownerid: '',
                apiid: '',
                apikey: '',
                zzownerid: '',
                idsname: '',
                planName: '',
                haplink: '',
                appid: '',
                targetid: '',
                creativityid: ''
            }

            this.editingAccounts.unshift(newAccount)
        },

        // 在弹窗中删除录户
        handleDeleteAccountInDialog(account, index) {
            if (account.id) {
                this.$confirm('确定要删除该录户吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.deleteAccount(account, index)
                }).catch(() => { })
            } else {
                this.editingAccounts.splice(index, 1)
                this.$message.success('已移除')
            }
        },

        async deleteAccount(account, index) {
            try {
                const response = await axios.delete(`${this.baseUrl}/account/delete`, {
                    params: { id: account.id }
                })

                if (response.data.code === 200) {
                    this.$message.success('删除成功')
                    this.editingAccounts.splice(index, 1)
                } else {
                    this.$message.error(response.data.msg || '删除失败')
                }
            } catch (error) {
                console.error('删除录户失败:', error)
                this.$message.error('删除失败: ' + error.message)
            }
        },

        // 保存项目修改
        async saveProjectAccounts() {
            const accountsToSave = this.editingAccounts.filter(account => {
                return account.twoname || account.url || account.baoguangurl ||
                    account.xiaoshuourl || account.ownerid || account.apiid ||
                    account.apikey || account.zzownerid || account.idsname ||
                    account.planName || account.haplink || account.appid ||
                    account.targetid || account.creativityid
            })

            const validAccounts = accountsToSave.map(account => ({
                ...account,
                projectId: account.projectId || this.currentProject.projectId,
                username: this.currentProject.projectName
            }))

            if (validAccounts.length === 0) {
                this.$message.warning('没有有效数据需要保存')
                return
            }

            this.saveLoading = true

            try {
                const response = await axios.post(`${this.baseUrl}/accounts/save`, validAccounts)

                if (response.data.code === 200) {
                    this.$message.success(response.data.msg)
                    this.accountDialogVisible = false
                    this.loadProjects()
                } else {
                    this.$message.error(response.data.msg || '保存失败')
                }
            } catch (error) {
                console.error('保存失败:', error)
                this.$message.error('保存失败: ' + error.message)
            } finally {
                this.saveLoading = false
            }
        },

        // 删除项目
        handleDeleteProject(project) {
            this.$confirm(`确定要删除项目"${project.projectName}"吗？`, '警告', {
                type: 'warning',
                confirmButtonText: '确认删除',
                cancelButtonText: '取消'
            }).then(() => {
                this.deleteProject(project.projectId)
            }).catch(() => { })
        },

        async deleteProject(projectId) {
            try {
                const response = await axios.delete(`${this.baseUrl}/project/delete`, {
                    params: { projectId: projectId }
                })

                if (response.data.code === 200) {
                    this.$message.success('项目删除成功')
                    this.loadProjects()
                } else {
                    this.$message.error(response.data.msg || '删除失败')
                }
            } catch (error) {
                console.error('删除项目失败:', error)
                this.$message.error('删除失败: ' + error.message)
            }
        },

        // 下载Excel模板
        downloadTemplate() {
            const headers = [
                ['子项目名称', '广告h5落地链接', '曝光URL', '点击监测链接', '代理商账户id', '代理商账户api id', 
                 '代理商账户apikey', '子账户id', '账户名称', '计划名称', 'hap链接', '快应用id', '定向包id', '创意ID']
            ];
            
            const exampleData = [
                ['示例子项目', 'https://example.com/landing', 'https://example.com/exposure', 
                 'https://example.com/click', 'agent123', 'api123', 'key123', 
                 'sub123', '示例账户', '示例计划', 'https://example.com/hap', 
                 'app123', 'target123', '创意123']
            ];
            
            const wb = XLSX.utils.book_new();
            const templateWs = XLSX.utils.aoa_to_sheet(headers);
            XLSX.utils.book_append_sheet(wb, templateWs, '模板');
            const exampleWs = XLSX.utils.aoa_to_sheet([...headers, ...exampleData]);
            XLSX.utils.book_append_sheet(wb, exampleWs, '示例');
            
            XLSX.writeFile(wb, `OPPO录户导入模板.xlsx`);
            this.$message.success('模板下载成功');
        },

        // 处理Excel上传
        async handleExcelUpload(file) {
            // 验证文件类型
            const isExcel = file.type === 'application/vnd.ms-excel' || 
                           file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                           file.name.endsWith('.xlsx') || 
                           file.name.endsWith('.xls');
            
            if (!isExcel) {
                this.$message.error('只能上传Excel文件（.xlsx 或 .xls 格式）');
                return false;
            }

            const loading = this.$loading({
                lock: true,
                text: '正在解析Excel文件...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                const data = await this.readExcelFile(file);
                const accounts = this.parseExcelData(data, this.currentProject);
                
                if (accounts.length === 0) {
                    this.$message.warning('Excel中没有有效数据');
                    loading.close();
                    return false;
                }

                // 将解析出的账户添加到编辑列表中
                this.editingAccounts = [...accounts, ...this.editingAccounts];
                
                this.$message.success(`成功解析 ${accounts.length} 条数据，请点击保存按钮提交`);
            } catch (error) {
                console.error('解析Excel失败:', error);
                this.$message.error('解析Excel失败: ' + (error.message || '未知错误'));
            } finally {
                loading.close();
            }

            return false;
        },

        // 读取Excel文件
        readExcelFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        resolve(jsonData);
                    } catch (error) {
                        reject(error);
                    }
                };
                
                reader.onerror = (error) => reject(error);
                reader.readAsArrayBuffer(file);
            });
        },

        // 解析Excel数据
        parseExcelData(data, project) {
            if (!data || data.length < 2) return [];
            
            const accounts = [];
            
            // 从第2行开始遍历数据
            for (let i = 1; i < data.length; i++) {
                const row = data[i];
                if (!row || row.length === 0) continue;
                
                const isEmpty = row.every(cell => !cell || cell.toString().trim() === '');
                if (isEmpty) continue;
                
                const account = {
                    id: null,
                    projectId: project.projectId,
                    username: project.projectName,
                    twoname: row[0] ? row[0].toString().trim() : '',
                    url: row[1] ? row[1].toString().trim() : '',
                    baoguangurl: row[2] ? row[2].toString().trim() : '',
                    xiaoshuourl: row[3] ? row[3].toString().trim() : '',
                    ownerid: row[4] ? row[4].toString().trim() : '',
                    apiid: row[5] ? row[5].toString().trim() : '',
                    apikey: row[6] ? row[6].toString().trim() : '',
                    zzownerid: row[7] ? row[7].toString().trim() : '',
                    idsname: row[8] ? row[8].toString().trim() : '',
                    planName: row[9] ? row[9].toString().trim() : '',
                    haplink: row[10] ? row[10].toString().trim() : '',
                    appid: row[11] ? row[11].toString().trim() : '',
                    targetid: row[12] ? row[12].toString().trim() : '',
                    creativityid: row[13] ? row[13].toString().trim() : ''
                };
                
                accounts.push(account);
            }
            
            return accounts;
        }
    }
}
</script>
  
<style scoped>
.app-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 84px);
}

.operation-card {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
}

.operation-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.projects-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
}

.search-bar {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
}

.search-tip {
    color: #409eff;
    font-size: 14px;
}

.empty-state {
    padding: 40px 0;
}

.project-table {
    margin-top: 10px;
}

.project-table :deep(.el-table__header th) {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
}

.dialog-toolbar {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
}

.account-table {
    margin: 0;
}

.account-table :deep(.el-table__header th) {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
}

.account-table :deep(.el-input__wrapper) {
    padding: 1px 8px;
}

.account-table :deep(.el-input__inner) {
    height: 32px;
    line-height: 32px;
}

.dialog-footer {
    text-align: right;
}






:deep(.el-dialog__body) {
    padding: 20px;
}

:deep(.el-button--small) {
    padding: 6px 12px;
}

@media (max-width: 768px) {
    .app-container {
        padding: 10px;
    }

    .search-bar {
        justify-content: center;
        flex-wrap: wrap;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/oppo/oppoaccunt.vue